// src/components/gallery/PhotoModal.jsx
import { Heart, Eye, Download, ChevronLeft, ChevronRight } from "lucide-react";

const PhotoModal = ({ photo, photos, currentIndex, onClose, onPrev, onNext }) => {
  if (!photo) return null;

  const handleDownload = (url, filename) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
    // The 'download' attribute is optional here, as the S3 URL includes it in the query parameters, 
    // but you can include it to provide a local file name hint.
    const suggestedFileName = "download.JPG";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm">
      <div className="relative max-w-6xl max-h-[90vh] w-full mx-4 flex items-center justify-center">
        {/* Previous Button */}
        {currentIndex > 0 && (
          <button
            onClick={onPrev}
            className="absolute left-2 md:left-6 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors z-10"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
        )}

        {/* Image */}
        <img
          src={(photo?.preview || photo?.url) + "?w=1200&h=800&fit=contain"}
          alt={photo?.title}
          className="max-w-full max-h-[80vh] object-contain object-center rounded-lg"
        />

        {/* Next Button */}
        {currentIndex < photos.length - 1 && (
          <button
            onClick={onNext}
            className="absolute right-2 md:right-6 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors z-10"
          >
            <ChevronRight className="h-6 w-6" />
          </button>
        )}

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors"
        >
          ✕
        </button>

        {/* Bottom Info Bar */}
        <div className="absolute bottom-4 left-4 right-4 bg-black/70 text-white p-4 rounded-lg">
          <h3 className="text-xl font-bold mb-2">{photo.title}</h3>
          <div className="flex items-center justify-between text-sm">
            <span>Uploaded {photo.uploadDate}</span>
            <div className="flex items-center space-x-4">
              <span className="flex items-center">
                <Heart className="h-4 w-4 mr-1" />
                {photo.likes}
              </span>
              <span className="flex items-center">
                <Eye className="h-4 w-4 mr-1" />
                {photo.views}
              </span>
<a 
            href={photo?.original} 
            download={photo?.key.split('/').pop() || suggestedFileName}
            target="_blank" // Optional: Ensures the browser handles the download directly
            rel="noopener noreferrer"
            className="flex items-center bg-blue-600 px-3 py-1 rounded-lg hover:bg-blue-700 transition-colors"
        >
             <Download className="h-4 w-4 mr-1" /> Download
        </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotoModal;
